<template>
	<b-row class="calendar-container m-0">
		<b-col cols="12" class="p-0">
			<b-row class="m-0 title-row">
				<b-col v-for="(weekday, index) in moment.weekdays()" :key="index" class="pr-0 pl-lg-4 pl-md-0 calendar-title">
					{{weekday}}
				</b-col>
			</b-row>
			<b-row v-for="row in 6" :key="row" class="m-0 day-row">
				<b-col v-for="(weekday, index) in moment.weekdays()"
					   :key="index"
					   @click="showNewShiftForm($event, getCurrentDate(row, weekday).toDate())"
					   @drop="onShiftDrop($event, getCurrentDate(row, weekday).toDate())"
					   @dragover.prevent
					   @dragenter.prevent
					   :title="`Click to add new shift on ${getCurrentDate(row, weekday).format('ddd, DD MMM YYYY')}`"
					   :class="`day-square${(inCurrentMonth(row, weekday) ? '' : ' not-in-current-month')}`">
					<div v-if="getShiftsForDay(row, weekday).length < 3">
						<div v-for="(shift, index2) in getShiftsForDay(row, weekday)" :key="index2" class="shift-container" @dragstart="onShiftDrag($event, shift)" draggable>
							<div :class="`shift ${shift.statusColor}`"
								 @click="onShiftClick($event, shift)"
								 :title="`Click to view. Double click to edit. Drag to change date${shift.error != null ? `\nErrors:\n${shift.error}` : ''}`">>
								<div class="client-name">{{shift.clientfullname}}</div>
								<div v-if="shift.istimeclock" class="name" v-html="`${shift.shiftname}${(shift.servicetypename == '' ? '' : ' - ' + shift.servicetypename)}`"></div>
								<div v-else class="name">{{shift.shifttask}}</div>
								<div class="time">{{moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A").format("hh:mm a")}}</div>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="shift-container">
							<b-dropdown size="md"
										variant="link"
										class="shift multiple-shifts"
										menu-class="scroll-bar"
										toggle-class="text-decoration-none name"
										:ref="`multipleShifts${row}${weekday}`"
										v-b-popover.hover.html="getShiftPopoverContent(row, weekday)"
										:title="`${getCurrentDate(row, weekday).format('ddd, DD MMM YYYY')}`"
										no-caret>
								<template slot="button-content">
									{{getShiftsForDay(row, weekday).length}} shifts scheduled
								</template>
								<b-dropdown-header class="header" title="">
									<b-row class="m-0">
										<b-col class="p-0">
											{{getCurrentDate(row, weekday).format("ddd, DD MMM YYYY")}}
										</b-col>
										<b-col cols="auto" class="ml-auto p-0">
											<small><i class="mh-icon-close" @click="onMultipleShiftsClose($event, `multipleShifts${row}${weekday}`)"></i></small>
										</b-col>
									</b-row>
								</b-dropdown-header>
								<b-dropdown-text v-for="(shift, index2) in getShiftsForDay(row, weekday)" :key="index2" title="" class="shift-container" @dragstart="onShiftDrag($event, shift)" draggable>
									<div :class="`shift ${shift.statusColor}`"
										 @click="onShiftClick($event, shift)"
										 title="Click to view. Double click to edit. Drag to change date">
										<div class="client-name">{{shift.clientfullname}}</div>
										<div v-if="shift.istimeclock" class="name" v-html="`${shift.shiftname}${(shift.servicetypename == '' ? '' : ' - ' + shift.servicetypename)}`"></div>
										<div v-else class="name">{{shift.shifttask}}</div>
										<div class="time">{{moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A").format("hh:mm a")}}</div>
									</div>
								</b-dropdown-text>
							</b-dropdown>
						</div>
					</div>
					<div class="day-number">{{getCurrentDate(row, weekday).format("D")}}</div>
				</b-col>
			</b-row>
		</b-col>

		<b-modal ref="forms" :visible="isShowingShiftForm"
				 @hide="hideShiftForm"
				 size="lg"
				 :modal-class="'shift-form' + (creating ? ' creating': ' editing')"
				 body-class="mh-off-middle"
				 hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">{{moment(selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("dddd, MMM D, YYYY")}}</h5>
			</template>
			<template slot="default">
				<ShiftForm @close-form="hideShiftForm" @save-form="saveShift" :data="selectedRecord" />
			</template>
		</b-modal>

		<b-modal ref="forms" :visible="isShowingCancelShiftForm"
				 @hide="hideCancelShiftForm"
				 size="lg"
				 modal-class="shift-form cancel"
				 body-class="mh-off-middle"
				 hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">Cancel shift for {{selectedRecord.clientfullname}} on {{moment(selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("dddd, MMM D, YYYY")}}</h5>
			</template>
			<template slot="default">
				<CancelShiftForm @close-form="hideCancelShiftForm" @save-form="cancelShift" :data="selectedRecord" />
			</template>
		</b-modal>

		<b-modal v-if="isShowingShiftSummary"
				 :visible="isShowingShiftSummary"
				 @hide="hideShiftSummary"
				 size="md"
				 modal-class="shift-summary"
				 hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">{{moment(selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("dddd, MMM D, YYYY")}}</h5>
			</template>
			<template slot="default">
				<ShiftDetails :data="selectedRecord"
							  @cancel-shift="showCancelShiftForm(selectedRecord)"
							  @edit-shift="showEditShiftForm(selectedRecord)"
							  @delete-shift="deleteShift(selectedRecord)" />
			</template>
		</b-modal>
	</b-row>
</template>

<script>
	import ShiftForm from "./ShiftForm"
	import ShiftDetails from "./ShiftDetails"
	import CancelShiftForm from "./CancelShiftForm"
	import moment from "moment"

	export default {
		name: 'ScheduleBoardMonthView',
		components: {
			ShiftForm,
			ShiftDetails,
			CancelShiftForm
		},
		props: {
			date: null,
			period: null,
			filters: null
		},
		data: function () {
			return {
				gettingShifts: false,
				shiftClickCount: 0,
				viewing: false,
				creating: false,
				editing: false,
				cancelling: false,
				selectedRecord: {
					servicedate: moment().format("D/MM/YYYY hh:mm:ss A")
				}
			}
		},
		mounted: function () {
			this.getShifts()
		},
		watch: {
			date: {
				immediate: true,
				handler(newValue, oldValue) {
					this.getShifts()
				}
			},
			period: {
				immediate: true,
				handler(newValue, oldValue) {
					this.getShifts()
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			shifts: function () {
				return this.getFilteredShifts(this.$store.state.Shifts.shifts)
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			selectedRecordCustomer: function () {
				return this.customers.filter(x => x.id == this.selectedRecord.clientid)[0]
			},
			customerProfilePicture: function () {
				return this.selectedRecordCustomer.profilepic
			},
			dateFrom: function () {
				return moment().day("Sunday").week(moment(this.date).startOf('month').week()).toDate()
			},
			dateTo: function () {
				return moment().day("Saturday").week(moment(this.date).startOf('month').week() + 5).toDate()
			},
			statusValues: function () {
				return this.$store.state.Shifts.statusValues
			},
			statusColors: function () {
				return this.$store.state.Shifts.statusColors
			},
			isShowingShiftForm: function () {
				return !this.viewing && (this.creating || this.editing)
			},
			isShowingCancelShiftForm: function () {
				return !this.viewing && this.cancelling
			},
			isShowingShiftSummary: function () {
				return this.viewing
			},
			canCancelShift: function () {
				return this.selectedRecord.allStatuses == this.statusValues.pending
					|| this.selectedRecord.allStatuses == this.statusValues.unconfirmed
					|| this.selectedRecord.allStatuses == this.statusValues.scheduled
					|| this.selectedRecord.allStatuses == this.statusValues.unpublished
			},
			canEditShift: function () {
				return this.selectedRecord.allStatuses == this.statusValues.pending
					|| this.selectedRecord.allStatuses == this.statusValues.unconfirmed
					|| this.selectedRecord.allStatuses == this.statusValues.scheduled
					|| this.selectedRecord.allStatuses == this.statusValues.unpublished
			}
		},
		methods: {
			getCurrentDate: function (row, weekday) {
				return moment().day(weekday).week(moment(this.date).startOf('month').week() + (row - 1))
			},
			inCurrentMonth: function (row, weekday) {
				return this.getCurrentDate(row, weekday).format("MM/YYYY") == moment(this.date).format("MM/YYYY")
			},
			getShifts: function () {
				var $this = this

				if (this.gettingShifts || this.$store.state.Customers.customers.length < 1)
					return

				this.gettingShifts = true

				this.$store.dispatch(
					"Shifts/getShiftsForRange",
					{
						fromDate: moment(this.dateFrom).format('YYYY-MM-DD'),
						toDate: moment(this.dateTo).format('YYYY-MM-DD'),
						showLoading: true
					}
				).then(function () {
					$this.$emit("shifts", $this.shifts)
					$this.gettingShifts = false
				})
			},
			getShiftsForDay: function (row, weekday) {
				var currentDate = this.getCurrentDate(row, weekday)

				return this.shifts
					.filter(x => moment(x.servicedate, "D/MM/YYYY hh:mm:ss A").format("DD/MM/YYYY") == currentDate.format("DD/MM/YYYY"))
			},
			getShiftPopoverContent: function (row, weekday) {
				var shifts = this.getShiftsForDay(row, weekday)

				var html = ""

				for (var i = 0; i < shifts.length; i++) {
					var shift = shifts[i]

					html += `
						<div class="row m-0">
							<div class="col-8 p-0">${shift.clientfullname}</div>
							<div class="col-4 p-0">${moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A").format("hh:mm a")}</div>
						</div>
					`
				}

				return html
			},
			getFilteredShifts: function (shifts) {
				return shifts
					.filter(shift => {
						return (this.filters.status.pending && shift.allStatuses == this.statusValues.pending)
							|| (this.filters.status.unconfirmed && shift.allStatuses == this.statusValues.unconfirmed)
							|| (this.filters.status.scheduled && shift.allStatuses == this.statusValues.scheduled)
							|| (this.filters.status.completed && shift.allStatuses == this.statusValues.completed)
							|| (this.filters.status.cancelled && shift.allStatuses == this.statusValues.cancelled)
							|| (this.filters.status.unpublished && shift.allStatuses == this.statusValues.unpublished)
					})
			},
			onShiftClick: function (event, shift) {
				event.stopPropagation()

				this.shiftClickCount++

				if (this.shiftClickCount == 1) {
					var $this = this

					this.$store.dispatch(
						"Timeouts/set",
						{
							name: "ShiftScheduleBoardCustomer",
							callback: function () {
								$this.showShiftSummary(shift)
								$this.shiftClickCount = 0
							},
							timeout: 500
						})
				}
				else {
					this.$store.commit("Timeouts/clear", "ShiftScheduleBoardCustomer")
					this.showEditShiftForm(shift)
					this.shiftClickCount = 0
				}
			},
			onShiftDrag: function (event, shift) {
				this.selectedRecord = shift
			},
			onShiftDrop: function (event, date) {
				var serviceDate = moment(`${moment(date).format("DD/MM/YYYY")} ${moment(this.selectedRecord.servicedate, "D/MM/YYYY hh:mm:ss A").format("hh:mm:ss A")}`, "D/MM/YYYY hh:mm:ss A")
				var difference = moment(date).diff(moment(this.selectedRecord.servicedate, "DD/MM/YYYY"))
				var endDate = moment(this.selectedRecord.enddate, "D/MM/YYYY hh:mm:ss A").add(moment.duration(difference).days(), "days")

				var parameters = {
					id: this.selectedRecord.servicescheduleid,
					name: this.selectedRecord.name,
					userId: this.selectedRecord.employeeid,
					clientId: this.selectedRecord.clientid,
					start: serviceDate.format("HH:mm"),
					end: endDate.format("HH:mm"),
					date: serviceDate.format("YYYY-MM-DD"),
					dateTo: endDate.format("YYYY-MM-DD"),
					serviceTypeId: this.selectedRecord.servicetypeid,
					billable: !this.selectedRecord.istimeclock,
					days: "",
					interval: 0,
					shiftNotes: this.shiftnotes,
					SendEmailNotification: false,
					CreateShiftWithErrors: true
				}

				var $this = this

				this.$store.dispatch("Shifts/saveShift", parameters).then(function (response) {
					$this.getShifts()
				})

				this.selectedRecord = this.getDefaultShift(new Date())
			},
			getDefaultShift: function (date) {
				return {
					servicedate: moment(date).format("D/MM/YYYY hh:mm:ss A")
				}
			},
			showShiftSummary: function (shift) {
				this.selectedRecord = shift
				this.viewing = true
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			hideShiftSummary: function () {
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			showNewShiftForm: function (event, date) {
				event.stopPropagation()

				this.selectedRecord = this.getDefaultShift(date)

				this.viewing = false
				this.creating = true
				this.editing = false
				this.cancelling = false
			},
			showEditShiftForm: function (shift) {
				this.selectedRecord = shift
				this.viewing = false
				this.creating = false
				this.editing = true
				this.cancelling = false
			},
			showCancelShiftForm: function (shift) {
				this.selectedRecord = shift
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = true
			},
			hideShiftForm: function () {
				this.selectedRecord = this.getDefaultShift(new Date())
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			hideCancelShiftForm: function () {
				this.selectedRecord = this.getDefaultShift(new Date())
				this.viewing = false
				this.creating = false
				this.editing = false
				this.cancelling = false
			},
			saveShift: function () {
				this.getShifts()
			},
			cancelShift: function () {
				this.getShifts()
				this.hideCancelShiftForm()
			},
			deleteShift: function (obj) {
				if (obj.timesheetapproved == "True") {
					this.$store.commit("Toasts/showWarning", { title: "Shift", content: "Shift is approved and cannot be deleted!" })

					return
				}

				this.$store.commit("Confirmation/show", {
					text: `Are you sure you want to delete <b>${obj.clientfullname} - ${obj.shiftname}</b> on <b>${moment(obj.servicedate, "DD/MM/YYYY hh:mm:ss A").format("DD MMM YYYY")}</b> at <b>${moment(obj.servicedate, "DD/MM/YYYY hh:mm:ss A").format("hh:mm A")} - ${moment(obj.enddate, "DD/MM/YYYY hh:mm:ss A").format("hh:mm A")}</b>?`,
					okCallback: () => {
						this.$store.dispatch(
							"Shifts/DeleteShift",
							{
								timesheetId: obj.timesheetid,
								serviceScheduleId: obj.servicescheduleid
							})
							.then(() => {
								this.viewing = false

								this.getShifts()
							})
					},
					cancelCallback: null
				})
			},
			onMultipleShiftsClose: function (event, ref) {
				event.stopPropagation();

				this.$refs[ref][0].hide()
			}
		}
	}
</script>

<style>
	.calendar-container > div .title-row .calendar-title {
		flex-direction: row;
		flex-wrap: nowrap;
		font-size: 13px;
		background-color: #eceff5;
		color: #081e4a;
		padding: 25px 15px;
		overflow: hidden;
		text-overflow: ellipsis;
	}

		.calendar-container > div .title-row .calendar-title:first-child {
			border-top-left-radius: 15px;
		}

		.calendar-container > div .title-row .calendar-title:last-child {
			border-top-right-radius: 15px;
		}

	.calendar-container > div .day-row .day-square {
		position: relative;
		height: 170px;
		padding: 15px 0;
		font-size: 11px;
		border-left: 1px solid #f3f5f8;
		border-bottom: 1px solid #f3f5f8;
	}

		.calendar-container > div .day-row .day-square:last-child {
			border-right: 1px solid #f3f5f8;
		}

	.calendar-container > div .day-row:last-child .day-square:first-child {
		border-bottom-left-radius: 15px;
	}

	.calendar-container > div .day-row:last-child .day-square:last-child {
		border-bottom-right-radius: 15px;
	}

	.calendar-container > div .day-row .day-square.not-in-current-month {
		color: #dadada;
	}

	.calendar-container > div .day-row .day-square .day-number {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.calendar-container > div .day-row .day-square .shift-container .shift {
		position: relative;
		float: left;
		width: 100%;
		border: 1px solid #f3f5f8;
		font-size: 11px;
		cursor: pointer;
		padding: 5px;
		word-break: break-word;
	}

		.calendar-container > div .day-row .day-square .shift-container .shift .name {
			width: 100%;
			font-weight: bold;
			filter: brightness(95%);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.calendar-container > div .day-row .day-square .shift-container .shift .time {
			filter: brightness(95%);
		}

	.calendar-container > div .day-row .day-square.not-in-current-month .shift-container .shift {
		filter: opacity(0.3);
	}

	.calendar-container > div .day-row .day-square .shift-container .shift .name {
		width: 100%;
		font-weight: bold;
		filter: brightness(95%);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.calendar-container > div .day-row .day-square .shift-container .shift .time {
		filter: brightness(95%);
	}

		.calendar-container > div .day-row .day-square .shift-container .shift.multiple-shifts .name {
			display: inline;
			height: unset !important;
			padding: 0 !important;
			font-size: 11px;
			color: #828181 !important;
		}

		.calendar-container > div .day-row .day-square .shift-container .shift.multiple-shifts .dropdown-menu {
			padding: 0 !important;
			padding-top: 0 !important;
			border-radius: 25px;
			max-height: 300px;
			overflow: auto;
			border: 5px solid #081e4a;
		}

			.calendar-container > div .day-row .day-square .shift-container .shift.multiple-shifts .dropdown-menu .header {
				position: sticky;
				top: 0;
				left: 0;
				right: 0;
				padding: 5px 0;
				background-color: #081e4a;
				border-top-left-radius: 15px;
				border-top-right-radius: 15px;
				z-index: 1;
			}

				.calendar-container > div .day-row .day-square .shift-container .shift.multiple-shifts .dropdown-menu .header .dropdown-header {
					color: #ffffff;
				}

			.calendar-container > div .day-row .day-square .shift-container .shift.multiple-shifts .dropdown-menu .shift-container .b-dropdown-text {
				margin-bottom: -4px !important;
				padding: 0 !important;
				font-weight: unset !important;
			}

			.calendar-container > div .day-row .day-square .shift-container .shift.multiple-shifts .dropdown-menu .shift-container:last-child .b-dropdown-text .shift {
				border-bottom-left-radius: 15px;
				border-bottom-right-radius: 15px;
			}

	.calendar-container > div .day-row .day-square .shift-container .shift .client-name {
		width: 100%;
		font-weight: bold;
		filter: brightness(95%);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>